/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EventLog } from '../models/event-log';
import { getEventLog } from '../fn/event-log-controller/get-event-log';
import { GetEventLog$Params } from '../fn/event-log-controller/get-event-log';

@Injectable({ providedIn: 'root' })
export class EventLogControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventLogControllerGetEventLog()` */
  static readonly EventLogControllerGetEventLogPath = '/admin/log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEventLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEventLog$Response(params?: GetEventLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EventLog>>> {
    return getEventLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEventLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEventLog(params?: GetEventLog$Params, context?: HttpContext): Observable<Array<EventLog>> {
    return this.getEventLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EventLog>>): Array<EventLog> => r.body)
    );
  }

}
